/* eslint-disable */

import Vue from 'vue';
import moment from 'moment';
export const pageMapper = {
    data() {
    return {
    dquestions1:[],
    finalNavigation:[],
    pageDataRc2:{},
   // page_name:'',
    navigation_mapper:[{
    route:"rc2/dwelling",
    page_name:'dwelling',
    sections:['Dwelling Details','Property Features']
    },
    {
    route:'rc2/coverage',
    page_name:'coverage',
    sections:['Coverage Details']
    },
    {
    route:'rc2/Mortgage',
    page_name:'Mortgage',
    sections:['New Mortgage']
    },
    {
    route:'rc2/try',
    page_name:'try',
    sections:['New try']
    }
   ],
    dquestions:[{
        ttile:'first question',uiField:'radio'},
       {ttile:'second question',uiField:'combox'},
       {ttile:'third question',uiField:'texbox'}],
    }
   },
    methods: {
         pageLayout(section,questions){
            this.pageDataRc2={};
            this.pageDataRc2.page_name=section;
            this.pageDataRc2.fields=[];
            this.tabButtons=[];
            console.log('this.pageData', questions);
            // Object.assign(this.pageDataRc2.fields,questions['Dwelling Details'].untitled)
            // Object.assign(this.pageDataRc2,this.fields);
            return this.pageDataRc2;
            // Object.assign(this.tabButtons,generateTabButtons())
          },
          
          generateTabButtons(){
              var tabButtons=[{},{}];
            tabButtons[0].name="dwelling";
            return tabButtons;
          },
          generatepage()
          {
          let dwelling = new pageLayout("Dwelling", "Dwelling Details",dquestions);
          
          var mortagage = new pageLayout("Mortage","Mortgage Information",dquestions);
          
          var coverage = new pageLayout ("Coverage","Musical Instrument",dquestions);
          
          console.log("Dwelling obj {}",dwelling);
          
          console.log("mortagage obj {}",mortagage);
          
          console.log("coverage obj {}",coverage);
          },

         getSections(RCresponse){
             let sections;
             let finalNav;
            RCresponse.forEach(elementMap => {
                 var navigations =  Object.getOwnPropertyNames(elementMap);
                 sections =navigations.filter(function (navigation) {
                    return navigation !== 'length';
                });
            });
            finalNav=this.generateTabs(sections)
            console.log('finalNav', finalNav);
            return finalNav;
          },
         generateTabs(sections)
          { 
            sections.forEach(section =>{
              this.navigation_mapper.forEach(nav=>{
                if(nav.sections.includes(section)){
                   this.finalNavigation.push(nav)
                  }
                })
              })
            return [...new Set(this.finalNavigation)];
          }
      
    }
};
export const homeRc2PageMapper = {
    // TODO: Remove this hack that suppresses the eslint error: Prefer default export "export const uiHelpers = {""
  };



// WEBPACK FOOTER //
// ./src/mixins/homeRc2PageMapper.js